import { useEffect, useRef, useState } from "react";
import { createTask } from "@/mutations/tasks";
import { Toast } from "@/components/Toast";

interface Props {
  prefillTitle: string;
}

export default function QuickNew({ prefillTitle }: Props) {
  const [title, setTitle] = useState(prefillTitle);
  const [myDay, setMyDay] = useState(false);
  const [toast, setToast] = useState<string | null>(null);
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  function submit(e: React.FormEvent) {
    e.preventDefault();
    const trimmed = title.trim();
    if (!trimmed) return;

    const saved = createTask({
      title: trimmed,
      myDay,
      via: "quick",
    });
    if (!saved) return;

    setTitle("");
    setMyDay(false);
    setToast("✓ Добавлено");
    inputRef.current?.focus();
    window.setTimeout(() => setToast(null), 1800);
  }

  return (
    <div className="min-h-dvh flex flex-col bg-white dark:bg-gray-900 text-gray-900 dark:text-gray-100">
      <header className="flex items-center justify-between px-4 py-3 border-b border-gray-200 dark:border-gray-800">
        <h1 className="text-lg font-semibold">Быстрая задача</h1>
        <a
          href="/my-day"
          aria-label="Закрыть"
          className="p-2 -mr-2 rounded text-gray-500 hover:text-gray-900 dark:hover:text-gray-100"
        >
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </a>
      </header>

      <form onSubmit={submit} className="flex-1 flex flex-col p-4 gap-4">
        <input
          ref={inputRef}
          type="text"
          inputMode="text"
          enterKeyHint="done"
          autoComplete="off"
          placeholder="Название задачи"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          className="w-full text-lg px-3 py-3 bg-transparent border-b border-gray-300 dark:border-gray-700 focus:outline-none focus:border-blue-500"
        />

        <label className="flex items-center gap-3 text-sm text-gray-600 dark:text-gray-400 select-none">
          <input
            type="checkbox"
            checked={myDay}
            onChange={(e) => setMyDay(e.target.checked)}
            aria-label="В «Мой день»"
            className="w-4 h-4 accent-blue-500"
          />
          В «Мой день»
        </label>

        <div className="flex-1" />

        <button
          type="submit"
          disabled={!title.trim()}
          className="w-full py-4 rounded-lg bg-blue-500 text-white font-semibold disabled:opacity-40 disabled:cursor-not-allowed"
        >
          Сохранить
        </button>
      </form>

      <Toast />
      {toast && (
        <div
          role="status"
          aria-live="polite"
          className="fixed left-1/2 -translate-x-1/2 bottom-24 px-4 py-2 rounded-full bg-gray-900 dark:bg-gray-100 text-white dark:text-gray-900 text-sm shadow-lg"
        >
          {toast}
        </div>
      )}
    </div>
  );
}
